import { validationSchema } from '../../util/auth';

import { useAppSelector } from '../../hook/useAppSelector';
import { useLoginErrorMessage } from '../../hook/login/useLoginErrorMessage';
import { useRememberMe } from '../../hook/login/useRememberMe';

import store, { AppDispatch } from '../../store/store';
import { authenticate, setErrorMessage } from '../../store/slice/auth';

import signInArrow from '../../assets/img/png/login/sign-in-arrow.png';
import hidePassword from '../../assets/img/svg/login/hide-password.svg';
import showPassword from '../../assets/img/svg/login/show-password.svg';

import { ActionFunctionArgs, Form, redirect, useNavigation } from 'react-router-dom';

import { RequestStatus } from '../../enum/RequestStatus';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getConfig, loadConfigFromBackend } from '../../store/slice/config/config';

const LoginForm: React.FC = () => {
  const [shouldShowPassword, setShouldShowPassword] = useState(false);
  const navigation = useNavigation();
  const isLoading = useAppSelector((state) => state.auth.isLoading);

  const { error } = useLoginErrorMessage();
  const { shouldRememberMe, setShouldRememberMe, username, setUsername } = useRememberMe();

  const { t } = useTranslation();

  return (
    <div className="login_form">
      {error && !isLoading && <div className="login_error message">{error}</div>}
      {isLoading && <div className="login_loader"></div>}

      <h1>
        <span>{t('loginPage.signIn')}</span>
        <img src={signInArrow} alt="sign_in_arrow"></img>
      </h1>

      <Form method="post" action="/login">
        <div className="form_pair">
          <input
            placeholder={t('loginPage.username')}
            name="username"
            type="text"
            defaultValue={username}
            onChange={(value) => {
              setUsername(value.target.value);
            }}
          ></input>
        </div>

        <div className="form_pair password">
          <input
            placeholder={t('loginPage.password')}
            name="password"
            type={shouldShowPassword ? 'text' : 'password'}
            autoComplete="off"
          ></input>
          <img
            src={shouldShowPassword ? showPassword : hidePassword}
            alt="toggle password"
            className="toggle_password"
            onClick={() => setShouldShowPassword((prevState) => !prevState)}
          />
        </div>

        <div className="form_pair checkbox">
          <input
            type="checkbox"
            name="shouldRememberMe"
            checked={shouldRememberMe}
            onChange={() => setShouldRememberMe((prevState) => !prevState)}
          ></input>
          <label>{t('loginPage.rememberMe')}</label>
        </div>

        <div className="login_button">
          <button type="submit" disabled={navigation.state === 'submitting'}>
            {t('loginPage.signIn')}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default LoginForm;

export async function authAction({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const username = formData.get('username') as string;
  const password = formData.get('password') as string;
  const dispatch = store.dispatch as AppDispatch;

  try {
    await validationSchema.validate({ username, password });

    const response = await store.dispatch(authenticate({ username, password }));

    if (response.meta.requestStatus === RequestStatus.FULFILLED) {
      dispatch(getConfig());
      dispatch(loadConfigFromBackend());
      return redirect('/');
    } else {
      store.dispatch(setErrorMessage('Login failed. Please try again.'));
    }
  } catch (error) {
    store.dispatch(setErrorMessage('Wrong username or password!'));
  }

  return null;
}
